// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y4N2","placeholdersHeader":"styles_placeholdersHeader__2M-A4","editorStyle":"styles_editorStyle__hVZFE","placeholdersBox":"styles_placeholdersBox__1oPVI"};